import EzModalController from 'layouts/modal/modal-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { LOGIN_CLICK } from 'components/analytics/conversions/constants/actions';

export default class SignupModalController extends EzModalController {
  connect() {
    super.connect();
  }

  trackLogin(event) {
    sendTrackingEvent({
      element: event.target,
      data: { action: LOGIN_CLICK },
    });
  }
}
